import { Component, Inject,  Pipe, PipeTransform, OnInit, HostListener, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettingService } from '../../app.service';
import { SkillAPIService } from '../skill-api.service';
import { SkillProfilerService } from './skill-profiler.service';

@Component({
	selector: 'app-skill-profiler',
	templateUrl: './skill-profiler.component.html',
	styleUrls: ['./skill-profiler.scss'],
	standalone: false
})
export class SkillProfilerComponent implements OnInit {
	constructor(
		private skillProfilerSrv: SkillProfilerService,
		private skillProfilerAPI: SkillAPIService,
		private router: Router,
		private dialog: MatDialog
	) { }

	assessmentCompleted:boolean = false;
	retrievingData: boolean = true;
	toggled: boolean = AppSettingService.widgetMobile();
	isMobile: boolean = AppSettingService.widgetMobile();
	private hasLoaded: boolean = false;

	tooltipValues = {
		retake: (window.innerWidth <= 1023) ? "" : "Retake",
		results: (window.innerWidth <= 1023) ? "" : "Results",
	};

	private setDisplay() {
		this.isMobile = AppSettingService.widgetMobile();
		this.toggled = !this.isMobile ? false : this.toggled;

		this.tooltipValues = {
			retake: (window.innerWidth <= 1023) ? "" : "Retake",
			results: (window.innerWidth <= 1023) ? "" : "Results",
		}

		this.ngOnInit();
	}

	toggleCollapse() {
		this.toggled = !this.toggled;
		this.ngOnInit();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.setDisplay();
	}

	goResults(event: any) {
		this.router.navigateByUrl("/SkillProfiler/Result");
	};

	takeAssessment(event: any) {
		this.router.navigateByUrl("/SkillProfiler/Assessment");
	};

	//#region result
	answers: any = null;
	skillResult: any = null;
	slides = [
		{ title: "BEST FIT", value: 'Best', iconFont: 'icnTrophy' },
		{ title: "GREAT FIT", value: 'Great', iconFont: 'icnMedal' },
		{ title: "GOOD FIT", value: 'Good', iconFont: 'icnAward' }
	];

	readMore(answer: any) {
		const popup = this.dialog.open(
			SkillResultReadMoreDialog,
			{
				panelClass: 'jmDialog',
				maxWidth: '850px',
				width: '90%',
				data: answer
			}
		);
		popup.afterClosed().subscribe(
			choice => {
				;
			}
		);
	}

	getResult(answers: any): void {
		this.answers = answers;
		this.skillProfilerAPI.getSkillResult().subscribe({
			next: (result: any) => {
				this.skillResult = result;
				const resultAnswer = result.Answers;
				this.retrievingData = false;

				//remove slides that don't contain matching fit value
				let slidesToSpliceVals = []; //array of string values of slides to splice after checking is done
				for (var i = 0; i < this.slides.length; i++) {
					var hasFit = false;
					for (var j = 0; j < resultAnswer.length; j++) {
						if (resultAnswer[j].Fit.toLowerCase() === this.slides[i].value.toLowerCase()) {
							hasFit = true;
						}
					}
					if (hasFit === false) {
						slidesToSpliceVals.push(this.slides[i].value);
					}
				}

				for (var i = 0; i < slidesToSpliceVals.length; i++) {
					for (var j = 0; j < this.slides.length; j++) {
						if (this.slides[j].value.toLowerCase() === slidesToSpliceVals[i].toLowerCase()) {
							this.slides.splice(j, 1);
							break;
						}
					}
				}
			},
			error: (err: any) => {
				console.log(err);
				this.retrievingData = false;
			}
		});
	}
	//#endregion result

	ngOnInit(): void {
		if (this.hasLoaded === false) {
			if ((this.isMobile && !this.toggled) || !this.isMobile) {
				this.hasLoaded = true;
				this.skillProfilerSrv.getSkillAnswers().subscribe({
					next: (result: any) => {
						if (result != null && result.Answers != null) {
							this.assessmentCompleted = true;
							this.getResult(result.Answers);
						}
						else {
							this.assessmentCompleted = false;
							this.retrievingData = false;
						}
					},
					error: (err: any) => {
						console.log(err);
						this.retrievingData = false;
						this.assessmentCompleted = false;
					}
				});
			}
		}
	};
}


@Component({
	template: `
		<div style="padding: 20px;">
			<div style="float: right;">
				<span role="button" (click)="close()" class="jmCloseBtn"></span>
			</div>
			<div style="display: flex; flex-direction: column;">
				<div>
					<b>{{answer.ElementName}}</b>
				</div>
				<div>
					<div style="margin-top: 20px;">
						{{answer.EasyReadDescription}}
					</div>
				</div>
			</div>
		</div>`,
	standalone: false
})
export class SkillResultReadMoreDialog {
	answer: any = null;
	constructor(
		public dialogRef: MatDialogRef<SkillResultReadMoreDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.answer = data;
	}

	close() {
		this.dialogRef.close(null);
	}
}
